import { tv } from 'tailwind-variants'

export const marginTop = tv({
  base: 'mt-0',
  variants: {
    space: {
      none: 'mt-0',
      xxsmall: 'mt-1',
      mini: 'mt-2',
      xsmall: 'mt-2.5',
      small: 'mt-4',
      medium: 'mt-5',
      gutter: 'mt-6',
      large: 'mt-8',
      xlarge: 'mt-12',
      xlargeMedium: 'mt-16',
      xxlarge: 'mt-20',
      xxlargeMedium: 'mt-28',
      xxxlarge: 'mt-40',
    },
  },
})

export const marginBottom = tv({
  base: 'mb-0',
  variants: {
    space: {
      none: 'mb-0',
      xxsmall: 'mb-1',
      mini: 'mb-2',
      xsmall: 'mb-2.5',
      small: 'mb-4',
      medium: 'mb-5',
      gutter: 'mb-6',
      large: 'mb-8',
      xlarge: 'mb-12',
      xlargeMedium: 'mb-16',
      xxlarge: 'mb-20',
      xxlargeMedium: 'mb-28',
      xxxlarge: 'mb-40',
    },
  },
})
